import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
const { INPUT, DATE, COMBO_BOX, TEXT_AREA } = FIELD_TYPE;

const cssProp = {
  css: { xl: 24, lg: 24, md: 24, sm: 24 },
  wrapperCol: { xl: 21, lg: 20, md: 18, sm: 16 },
  labelCol: { xl: 3, lg: 4, md: 6, sm: 8 },
};

const fields1: DataFormField[] = [
  // {
  //   type: INPUT,
  //   label: "Người đọc KQ",
  //   name: "nguoiDocKetQua",
  //   css: cssProp.css,
  //   labelCol: cssProp.labelCol,
  //   wrapperCol: cssProp.wrapperCol,
  // },
  {
    type: COMBO_BOX,
    label: "Mẫu điện tim",
    name: "mauDienTim",
    css: cssProp.css,
    labelCol: cssProp.labelCol,
    wrapperCol: cssProp.wrapperCol,
  },
];

const fields2: DataFormField[] = [
  {
    type: INPUT,
    label: "Kết luận",
    name: "ketLuan",
    css: cssProp.css,
    labelCol: cssProp.labelCol,
    wrapperCol: cssProp.wrapperCol,
  },
  {
    type: TEXT_AREA,
    label: "Lời dặn của bác sĩ",
    name: "loiDanBacSy",
    css: cssProp.css,
    labelCol: cssProp.labelCol,
    wrapperCol: cssProp.wrapperCol,
  },
];
export { fields1, fields2 };
